import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Spacer",
  tags: ["#page", "#inline"],
}

export default defineBlock("layout/spacer", (props) => {
  return (
    <div
      className={cn(
        "spacer content-sized flex",
        props.size === "1" && "py-1",
        props.size === "2" && "py-2",
        props.size === "3" && "py-3",
        props.size === "4" && "py-4",
        props.size === "5" && "py-5",
        props.size === "6" && "py-6",
        props.size === "7" && "py-7",
        props.size === "8" && "py-8",
        props.size === "9" && "py-9",
        props.size === "10" && "py-10",
      )}
    />
  )
})
